import React, { useState } from "react";
import logo from "../assets/MiLog1o.png";
import {
  FaBars,
  FaTimes,
  FaLinkedin,
  FaGithub,
  FaMoon,
  FaSun,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import { Link } from "react-scroll";
import { useDarkMode } from "../hooks/useDarkMode";
import { trackSectionView, trackDarkModeToggle } from "../utils/analytics";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const { isDarkMode, toggleDarkMode } = useDarkMode();
  const handleClick = () => setNav(!nav);

  // Manejar toggle de dark mode con tracking
  const handleDarkModeToggle = () => {
    toggleDarkMode();
    trackDarkModeToggle(!isDarkMode);
  };

  // Manejar navegación con tracking
  const handleNavigation = (sectionName) => {
    trackSectionView(sectionName);
    handleClick();
  };

  return (
    <nav
      id="main-navbar"
      className="fixed top-0 left-0 right-0 w-full h-20 flex justify-between items-center px-4 bg-white dark:bg-slate-900 dark:text-white shadow-lg border-b-2 border-blue-600 dark:border-blue-500  transition-colors duration-300"
      style={{ position: "fixed" }}
    >
      <div>
        <img src={logo} alt="logo" className="h-[70px]" />
      </div>
      {/*Menu*/}
      <ul className="hidden md:flex space-x-8 items-center">
        <li>
          <Link
            to="home"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => trackSectionView("Home")}
            className="font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Inicio
          </Link>
        </li>
        <li>
          <Link
            to="about"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => trackSectionView("About")}
            className="font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Sobre mí
          </Link>
        </li>
        <li>
          <Link
            to="skills"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => trackSectionView("Skills")}
            className="font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Habilidades
          </Link>
        </li>
        <li>
          <Link
            to="proyectos"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => trackSectionView("Projects")}
            className="font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Proyectos
          </Link>
        </li>
        <li>
          <Link
            to="contact"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={() => trackSectionView("Contact")}
            className="font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Contacto
          </Link>
        </li>

        {/* Toggle Modo Oscuro */}
        <li>
          <button
            onClick={handleDarkModeToggle}
            className="p-2 rounded-lg bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all duration-300 transform hover:scale-110"
            aria-label="Toggle dark mode"
          >
            {isDarkMode ? (
              <FaSun className="text-yellow-400" size={20} />
            ) : (
              <FaMoon className="text-slate-600" size={20} />
            )}
          </button>
        </li>
      </ul>

      {/*Menu Hamburguesa*/}
      <div className="md:hidden flex items-center gap-4">
        {/* Toggle Modo Oscuro en móvil */}
        <button
          onClick={handleDarkModeToggle}
          className="p-2 rounded-lg bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all duration-300"
          aria-label="Toggle dark mode"
        >
          {isDarkMode ? (
            <FaSun className="text-yellow-400" size={18} />
          ) : (
            <FaMoon className="text-slate-600" size={18} />
          )}
        </button>

        <div onClick={handleClick} className="z-10 cursor-pointer">
          {!nav ? <FaBars size={24} /> : <FaTimes size={24} />}
        </div>
      </div>
      {/*Menu Celular*/}
      <ul
        className={
          !nav
            ? "hidden"
            : "fixed top-0 left-0 w-full h-screen bg-white dark:bg-slate-900 flex flex-col justify-center items-center transition-colors duration-300 z-40"
        }
      >
        <li className="py-4">
          <Link
            onClick={() => handleNavigation("Home")}
            to="home"
            smooth={true}
            duration={500}
            offset={-80}
            className="text-2xl font-medium text-slate-800 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Inicio
          </Link>
        </li>
        <li className="py-4">
          <Link
            onClick={() => handleNavigation("About")}
            to="about"
            smooth={true}
            duration={500}
            offset={-80}
            className="text-2xl font-medium text-slate-800 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Sobre mí
          </Link>
        </li>
        <li className="py-4">
          <Link
            onClick={() => handleNavigation("Skills")}
            to="skills"
            smooth={true}
            duration={500}
            offset={-80}
            className="text-2xl font-medium text-slate-800 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Habilidades
          </Link>
        </li>
        <li className="py-4">
          <Link
            onClick={() => handleNavigation("Projects")}
            to="proyectos"
            smooth={true}
            duration={500}
            offset={-80}
            className="text-2xl font-medium text-slate-800 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Proyectos
          </Link>
        </li>
        <li className="py-4">
          <Link
            onClick={() => handleNavigation("Contact")}
            to="contact"
            smooth={true}
            duration={500}
            offset={-80}
            className="text-2xl font-medium text-slate-800 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300 cursor-pointer"
          >
            Contacto
          </Link>
        </li>
      </ul>
      {/*Social */}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0 z-40">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600">
            <a
              className="flex justify-between items-center w-full text-white"
              href="https://www.linkedin.com/in/abraham-molina/"
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-slate-800">
            <a
              className="flex justify-between items-center w-full text-white"
              href="https://github.com/Abrahanm7"
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-500 ">
            <a
              className="flex justify-between items-center w-full text-white"
              href="mailto:abrahanm7@gmail.com"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-slate-700">
            <a
              className="flex justify-between items-center w-full text-gray-300"
              href="/Cv-Abraham-Molina.pdf"
              download
            >
              Mi CV <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};
export default Navbar;
